import { diff } from './jsonDiff.js';

export const hasChanges = <TSchema>({ newData, oldData }: { oldData: TSchema; newData: TSchema }) => {
    return diff(oldData, newData) !== undefined;
};
